import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { FuncionarioDropDown } from "../../../../../common/domain/models/funcionario_dropdown";

type State = {
  IdItemProcesso: number;
  pesquisa: string | null,
  tipoPesquisa: number,
  funcionariosLista: FuncionarioDropDown[] | undefined,
};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setPesquisa: SetFunction<string | number | null>,
  setTipoPesquisa: SetFunction<number>,
  setFuncionariosLista: (funcionariosLista: FuncionarioDropDown[]) => void;

};


export const initialFiltersValues: State = {
  IdItemProcesso: 0,
  pesquisa: "",
  funcionariosLista: undefined,
  tipoPesquisa: 0,
};

export const useItemProcessosRiscosFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    funcionariosLista: state.funcionariosLista
  })),
  setFuncionariosLista: (funcionariosLista) => set({ funcionariosLista }),
}));